// extracted by mini-css-extract-plugin
export default {"message":"message_U5CfA","row":"row_HxNMn","col":"col_kA7PT","sideMenu":"sideMenu_q_NDg"};